import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-account-cancel-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './account-cancel-modal.component.html',
  styleUrl: './account-cancel-modal.component.css'
})
export class AccountCancelModalComponent {
  @Input() isSaving = false;
  @Input() errorMessage = '';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
